// Native types for filescanner API - replacing @filescannerApi/frontend-api

export enum UploadedFileStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  CHECKED = 'CHECKED',
  FAILED = 'FAILED',
  DELIVERED = 'DELIVERED',
  NON_EXISTENT = 'NON_EXISTENT'
}

export interface UploadedFile {
  file: string
  status: UploadedFileStatus
}

export interface StringPrimitiveWrapper {
  entityId: string
}

export interface CheckFileUploadRequest {
  file: Blob
  filename: string
}

export interface GetUploadedFileAsBase64Request {
  uploadedFileId: string
}
